<template>
    <v-select
        v-model="model_id"
        :filterable="false"
        :options="options"
        :reduce="option => option.id"
        class="style-chooser"
        label="label"
        placeholder=""
        @search="onSearch">
        <template slot="no-options">
            Start typing to search...
        </template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import _ from "lodash";

export default {
    name: "g-fk-filter",
    components: {vSelect},
    props: {
        filter: {
            type: Object,
        },
        formName: {
            type: String,
        },
        clear: {
            type: Boolean,
        }
    },
    data() {
        return {
            model_id: null,
            options: [],
        }
    },
    watch: {
        model_id(val) {
            this.$emit('vmodel', val, this.formName)
        },
        clear(val) {
            if (val) {
                this.model_id = null
            }
        }
    },
    methods: {
        onSearch(search, loading) {
            loading(true);
            if (search.length) {
                this.search(loading, search, this);
            } else {
                loading(false);
            }
        },
        search: _.debounce((loading, search, vm) => {
            axios.post('/apps/search' + `?search=${escape(search)}`, {
                table: vm.filter.table,
                id: vm.filter.column_id,
                name: vm.filter.column_name,
            })
                .then((response) => {
                    vm.options = response.data.data
                    loading(false);
                })
                .catch((err) => {
                    showMessage('e', 'Error get search');
                    loading(false);
                })
        }, 350)
    }
}
</script>

<style scoped>

</style>
